module.exports = __webpack_public_path__ + "static/img/icon-insurance-12.fdab3461.png";